<template>
  <div>
    <v-avatar>
      <img v-if="temFoto == 1" :src="fotoUser" :alt="'tec_' + id" :style="styleImg" />
      <img v-else src="../assets/user_tecnico.png" :alt="'te'" /> </v-avatar
    ><br />
    <!-- <small>{{ nomeUser }}</small> -->
  </div>
</template>
<script>
export default {
  props: ["id", "tecnicos","styleImg"],
  data: () => ({
    nomeUser: "",
    fotoUser: "",
    temFoto: 0,
  }),
  watch: {
    id: function () {
      this.carregaFoto();
    },
  },
  mounted() {
    this.carregaFoto();
  },

  methods: {
    carregaFoto() {
      if (this.id == 0) this.temFoto = 0;

      var vm = this;
      var img = this.tecnicos.filter((e) => {
        return e.id === vm.id ? e : null;
      });
      if (img.length <= 0) {
        this.fotoUser = "../assets/user_tecnico.png";
        this.nomeUser = "";
      } else {
        if (img[0].imgtec == null) {
          this.fotoUser = "../assets/user_tecnico.png";
          this.nomeUser = img[0].nome.substring(0, 10);
        } else {
          this.fotoUser = "data:image/jpeg;base64," + img[0].imgtec;
          this.nomeUser = img[0].nome.substring(0, 10);
          this.temFoto = 1;
        }
      }
    },
  },
};
</script>